module.exports = __webpack_public_path__ + "static/media/2023-VC-Feature-Banner-Desktop@2x.87e451f1.jpg";